import * as React from "react";

export const PauseButton: React.FC = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="22" cy="22" r="22" fill="#F5F5F5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 10C13.8954 10 13 10.8954 13 12V31C13 32.1046 13.8954 33 15 33H17.4286C18.5331 33 19.4286 32.1046 19.4286 31V12C19.4286 10.8954 18.5331 10 17.4286 10H15ZM26.5714 10C25.4669 10 24.5714 10.8954 24.5714 12V31C24.5714 32.1046 25.4669 33 26.5714 33H29C30.1046 33 31 32.1046 31 31V12C31 10.8954 30.1046 10 29 10H26.5714Z"
        fill="#474747"
      />
    </svg>
  );
};
